import StateColumn from "@/views/zhiji/pages/knowlege/components/StateColumn";
import PopOverText from "./PopOverText"
import i18n from "@/i18n";

// cluster页面-问题聚类管理
export const quesListTable = () => {
  return {
      columns: [
          {
              colId: "radio",
              header: "",
              type: "Radio",
              width: "5%"
          },
          {
              colId: "questionId",
              header: i18n.t("zhiji.knowlege.tabelCloumn.no"),
              type: "Text",
              width: "12%"
          },
          {
              colId: "standQuestion",
              header: i18n.t("zhiji.knowlege.standQustion"),
              type: "Link",
              width: "20%"
          },
          {
              colId: "referQuestions",
              header: i18n.t("zhiji.knowlege.referQuestions"),
              type: "Text",
              width: "18%",
          },
          {
              colId: "relateSimilarQuestion",
              header: i18n.t("zhiji.knowlege.similarQuestion"),
              type: "Text",
              width: "12%",
          },
          {
            colId: "language",
            header: i18n.t("zhiji.knowlege.language"),
            type: "Text",
            width: "8%",
          },
          {
              colId: "createrTime",
              header: i18n.t("zhiji.knowlege.tabelCloumn.createrTime"),
              type: "Text",
              width: "18%"
          },
          {
              colId: "state",
              header: i18n.t("zhiji.common.status"),
              type: "Custom",
              width: "14%",
              component: StateColumn
          },
      ],
      pageLength: 10,
      isHidePageLengthSelect: true,
  };
};

// 文本答案关联标准问题
export const searchSimilarQuesList = () => {
  return {
    columns: [
      {
        colId: "radio",
        header: "",
        type: "Radio",
        width: "46px"
      },
      {
        colId: "categorize",
        header: i18n.t("zhiji.knowlege.quesEditModal.categoriy"),
        type: "Custom",
        width: "206px",
        component: PopOverText,
      },
      {
        colId: "question",
        header: i18n.t("zhiji.knowlege.standQustion"),
        type: "Custom",
        width: "206px",
        component: PopOverText,
      },
      {
        colId: "language",
        header: i18n.t("zhiji.knowlege.language"),
        type: "Text",
        width: "103px",
      },
      {
        colId: "defaultLangReferQues",
        header: i18n.t("zhiji.knowlege.defaultLangReferQues"),
        type: "Custom",
        width: "206px",
        tooltip: i18n.t("zhiji.common.defaultLangReferQuesNotes"),
        component: PopOverText,
      },
      {
        colId: "state",
        header: i18n.t("zhiji.common.status"),
        type: "Custom",
        width: "140px",
        component: StateColumn
    },
    ],
    pageLength: 10,
    isHidePageLengthSelect: true,
  }
}
